import _axios from "axios"
const axios = _axios.create({
	baseURL: process.env.REACT_APP_API_ROOT,
	withCredentials: true,
})

export const getVoteInArticles = async (body) => {
	const response = await axios.post(`/campaign-new/vote-in-article/cms/list`, body)
	return response
}

export const getVoteInArticleById = async (id) => {
	const response = await axios.get(`/campaign-new/vote-in-article/cms/${id}`)
	return response
}

export const saveVoteInArticle = async (body) => {
	const response = await axios.post(`/campaign-new/vote-in-article/cms`, body)
	return response
}

export const editVoteInArticle = async (id, body) => {
	const response = await axios.put(`/campaign-new/vote-in-article/cms/${id}`, body)
	return response
}

export const getReportVoteInArticle = async (id) => {
	const response = await axios.get(`/campaign-new/vote-in-article/cms/${id}/report`)
	return response
}
export const getReportMemberVoteInArticle = async (id, page, limit) => {
	const response = await axios.get(`/campaign-new/vote-in-article/cms/${id}/report-member`, {
		params: {
			page,
			limit,
		},
	})
	return response
}

export const changeIsActive = async (id, isActive) => {
	const response = await axios.get(`/campaign-new/vote-in-article/cms/${id}/change-is-active`, {
		params: {
			isActive,
		},
	})
	return response
}
